export default "__VITE_ASSET__CNaceuJJ__"